import { DOWNLOAD } from '@wellsfargo/ecpfs-authority'

export const DOWNLOAD_E_SIGN_CONSENT = 'register/download/esign.json'

export function downloadEsign() {
	return DOWNLOAD(DOWNLOAD_E_SIGN_CONSENT)
}
